import React from 'react';
import ArticleField from '../ArticleField';
import { TextField } from '@material-ui/core';

interface LegendProps {
    value: string,
    onChange: (value: string) => void
}

const Legend = (props: LegendProps) => (
    <ArticleField>
        <TextField fullWidth={true}
            required
            label="Legende"
            value={props.value}
            onChange={(e) => {
                props.onChange(e.target.value);
        }} />
    </ArticleField>
);

export default Legend;
